
    export default {
      name: "FaqCityFromTo",
      props: {
        info_lading: {
          type: Object,
          default: {
            lading_page: [],
            reviews: [],
            price: []
          }
        },
        city_a: {
          type: String,
          default: '',
        },
        city_b: {
          type: String,
          default: '',
        }
      },
      data() {
        return {
          faq: [
            {
              title: `Как купить билет на автобус по маршруту ${this.city_a} - ${this.city_b}?`,
              answer: `Войдите на сайт o-kassa.com . В форме поиска билета укажите данные: Откуда ${this.city_a} Куда ${this.city_b} дату отправления и количество пассажиров и нажмите «Поиск». Среди предложенных вариантов выберите подходящий Вам рейс, выберите место в автобусе и оплатите его через интернет.`
            },
            {
              title: `Есть ли ограничения на поездки по направлению?`,
              answer: `На данный момент ограничений на поездки по маршруту ${this.city_a} - ${this.city_b} нет. Отдельные ограничения, в зависимости от выбранного рейса, прописаны в дополнительной информации перевозчика.`
            },
            {
              title: `Стоит ли искать билет ${this.city_a} - ${this.city_b} и покупать заранее?`,
              answer: `Большинство перевозчиков открывают продажу билетов ${this.city_a} - ${this.city_b} на 2-3 месяца вперед, как только начнете планировать свою поездку, лучшим решением будет заранее позаботиться о покупке билета по данному направлению.`
            },
            {
              title: `Почему есть прямой рейс ${this.city_a} - ${this.city_b} и с пересадками?`,
              answer: `В направлении ${this.city_a} - ${this.city_b} могут осуществлятся прямые рейсы и с пересадкой.`
            },
            {
              title: `Какой фактор влияет на конечную стоимость при покупке билета на автобус?`,
              answer: `Цена билетов по маршруту ${this.city_a}-${this.city_b} может меняться в зависимости от перевозчика, времени выезда или удобств автобуса. На данный момент минимальная цена на билет ${this.city_a}-${this.city_b} составляет ${this.info_lading?.price.price_min} BYN, а максимальная ${this.info_lading?.price.price_max} BYN`
            },
            {
              title: `Как часто автобусы ходят из города ${this.city_a}?`,
              answer: `Рейсы ${this.city_a}-${this.city_b} курсируют в зависимости от перевозчика. На данный момент мы стараемся делать все для того чтобы выезды были ежедневно`
            },
            {
              title: `Как много времени автобус ожидает на границе?`,
              answer: `Точно предугадать, сколько времени займет пограничный контроль, крайне сложно. Чаще всего перевозчики закладывают в маршрут около одного часа на таможню, однако ситуации бывают разные. Поэтому мы всегда рекомендуем оставлять некоторый запас времени при планировании дальнейшего своего времяпрепровождения.`
            },
            {
              title: `Какие автобусы ездят по направлению ${this.city_a}-${this.city_b}?`,
              answer: `Для поездок ${this.city_a}-${this.city_b} предоставляют большие комфортабельные автобусы евро класса. Больше деталей о транспортных средствах указано непосредственно возле каждого отдельного рейса.`
            },
            {
              title: `С каких городов отправляются автобусы в город ${this.city_b}?`,
              answer: `Войдите на сайт o-kassa.com. В разделе «Все маршруты» выберите страну и система выдаст вам список всех городов, из которых отправляются автобусы в город ${this.city_b}.`
            }
          ]
        }
      }
    }
